export default {
  methods: {
    async loadContent () {
      const promises = [];

      try {
        this.$store.commit('order/setSelectedTimeSlot', null);
        promises.push(this.$store.dispatch('order/loadSettings'));
        promises.push(this.$store.dispatch('order/loadMenu'));
        promises.push(this.$store.dispatch('order/loadTimeSlots'));
        await Promise.all(promises);
      } catch (err) {
        console.log(err);
      }
    }
  },

  created () {
    this.loadContent();
  },

  mounted () {
    window.channel.bind('timeslots', (data) => {
      this.$store.dispatch('order/loadTimeSlots', data);
    });

    window.channel.bind('settings', (data) => {
      const rand = Math.random() * (400 - 10) + 10;

      setTimeout(() => {
        this.$store.dispatch('order/loadSettings');
        this.$store.dispatch('order/loadTimeSlots');
      }, rand);
    });
  }
};
